"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = VisualPickerOption;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("../VisualPicker/context");

var _utils = require("../../libs/utils");

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _checkmarkIcon = _interopRequireDefault(require("./styled/checkmarkIcon"));

var _container = _interopRequireDefault(require("./styled/container"));

var _input = _interopRequireDefault(require("./styled/input"));

var _label = _interopRequireDefault(require("./styled/label"));

var _content = _interopRequireDefault(require("./styled/content"));

var _checkedTriangle = _interopRequireDefault(require("./styled/checkedTriangle"));

var _footer = _interopRequireDefault(require("./styled/footer"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var PickerOption = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(PickerOption, _Component);

  var _super = _createSuper(PickerOption);

  function PickerOption(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PickerOption);
    _this = _super.call(this, props);
    _this.inputId = (0, _utils.uniqueId)('radio');
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PickerOption, [{
    key: "getType",
    value: function getType() {
      var multiple = this.props.multiple;

      if (multiple) {
        return 'checkbox';
      }

      return 'radio';
    }
  }, {
    key: "isChecked",
    value: function isChecked() {
      var _this$props = this.props,
          multiple = _this$props.multiple,
          name = _this$props.name,
          value = _this$props.value;

      if (multiple) {
        return Array.isArray(value) && value.includes(name);
      }

      return typeof value === 'string' && name === value;
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props2 = this.props,
          name = _this$props2.name,
          privateOnChange = _this$props2.privateOnChange;
      privateOnChange(name, event.target.checked);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          disabled = _this$props3.disabled,
          children = _this$props3.children,
          footer = _this$props3.footer,
          style = _this$props3.style,
          className = _this$props3.className,
          size = _this$props3.size;
      var _this$props4 = this.props,
          groupName = _this$props4.groupName,
          ariaDescribedby = _this$props4.ariaDescribedby;
      return /*#__PURE__*/_react["default"].createElement(_container["default"], {
        "data-id": "visual-picker_option-container",
        className: className,
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
        as: "input",
        type: this.getType(),
        id: this.inputId,
        name: groupName,
        checked: this.isChecked(),
        "aria-describedby": ariaDescribedby,
        onChange: this.handleChange,
        disabled: disabled
      }), /*#__PURE__*/_react["default"].createElement(_label["default"], {
        "data-id": "visual-picker_option-label",
        htmlFor: this.inputId
      }, /*#__PURE__*/_react["default"].createElement(_content["default"], {
        "data-id": "visual-picker_option",
        size: size
      }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: this.isChecked()
      }, /*#__PURE__*/_react["default"].createElement(_checkedTriangle["default"], null), /*#__PURE__*/_react["default"].createElement(_checkmarkIcon["default"], null)), children), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
        isTrue: footer
      }, /*#__PURE__*/_react["default"].createElement(_footer["default"], null, footer))));
    }
  }]);
  return PickerOption;
}(_react.Component);
/**
 * A VisualPickerOption.
 * @category Form
 */


function VisualPickerOption(props) {
  return /*#__PURE__*/_react["default"].createElement(_context.Consumer, null, function (context) {
    return /*#__PURE__*/_react["default"].createElement(PickerOption, (0, _extends2["default"])({}, props, context));
  });
}

VisualPickerOption.propTypes = {
  /** It is a unique value that identifies the picker option. */
  name: _propTypes["default"].string,

  /** It is what will be displayed at the bottom of the component. */
  footer: _propTypes["default"].node,

  /** Specifies that an VisualPickerOption element should be disabled.
   * This value defaults to false. */
  disabled: _propTypes["default"].bool,

  /** The class name of the root element. */
  className: _propTypes["default"].string,

  /** It is an object with custom style applied to the root element. */
  style: _propTypes["default"].object,

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].object])
};
VisualPickerOption.defaultProps = {
  name: undefined,
  footer: undefined,
  disabled: false,
  className: undefined,
  style: undefined,
  children: []
};